// @flow

import { createContext } from 'react';
import { type Validation } from './types';

export const ValidationContext = createContext<Validation>({
  userInputValidationErrors: {},
  submitError: null,
});
